import type { ControllerSettings, LightboxExternalProps } from 'yet-another-react-lightbox'
import Lightbox from 'yet-another-react-lightbox'
import Zoom from 'yet-another-react-lightbox/plugins/zoom'

/**
 * 默认的 controller 配置
 * 全局统一使用这些配置，避免重复设置
 */
const defaultControllerSettings: Partial<ControllerSettings> = {
	closeOnBackdropClick: true,
	closeOnPullDown: true,
	closeOnPullUp: true,
}

/**
 * LightBox 组件 - 封装 yet-another-react-lightbox
 *
 * 这是一个薄封装层，透传所有必要的 props 到底层的 Lightbox 组件
 * 同时提供默认的 controller 配置，用户可以通过传入 controller prop 来覆盖
 */
export default function LightBox({ controller, ...props }: LightboxExternalProps) {
	return (
		<Lightbox
			{...props}
			plugins={[Zoom, ...(props.plugins || [])]}
			controller={{
				...defaultControllerSettings,
				...(controller || {}),
			}}
		/>
	)
}
